import { render, staticRenderFns } from "./UserPasswordEdit.vue?vue&type=template&id=46f1ff26&"
import script from "./UserPasswordEdit.vue?vue&type=script&lang=js&"
export * from "./UserPasswordEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports